import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PROCESS_STEPS, IMAGES } from "../data/site";
import { FadeUp, Stagger, StaggerItem } from "../components/motion";
import PageHeader from "../components/PageHeader";
import SEO from "../components/SEO";

const OurProcess = () => (
  <main>
    <SEO />
    <PageHeader
      testid="our-process-header"
      eyebrow="How We Build"
      lines={[{ text: "Simple Process," }, { text: "Serious Craft", italic: true }]}
      description="Building a home shouldn't feel like a mystery. Here's exactly how we work — five clear steps from first conversation to final walkthrough."
    />

    <section className="pb-24 md:pb-36">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <Stagger gap={0.12}>
          {PROCESS_STEPS.map((s, i) => (
            <StaggerItem key={s.n}>
              <div
                data-testid={`process-step-${s.n}`}
                className={`grid grid-cols-12 gap-6 md:gap-10 py-14 md:py-20 border-b border-[rgba(26,26,26,0.12)] items-start ${i % 2 === 1 ? "" : ""}`}
              >
                <span className="col-span-12 md:col-span-3 font-serif text-7xl md:text-9xl leading-none text-[#8C6A4F]/30 select-none">
                  {s.n}
                </span>
                <div className={`col-span-12 md:col-span-5 ${i % 2 === 1 ? "md:col-start-5" : ""}`}>
                  <h2 className="font-serif text-4xl md:text-6xl tracking-tight">{s.title}</h2>
                </div>
                <p className={`col-span-12 md:col-span-4 text-[#5C5A56] leading-relaxed text-base md:text-lg ${i % 2 === 1 ? "" : "md:col-start-9"}`}>
                  {s.text}
                </p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>

    <section className="relative py-28 md:py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img src="/work/w4.webp" alt="Great room with stone fireplace, wood beams, and arched built-ins by On Point Homes" className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-black/60" />
      </div>
      <div className="relative z-10 max-w-[1600px] mx-auto px-5 md:px-10">
        <FadeUp>
          <p className="font-serif text-3xl md:text-5xl text-[#F7F5F2] leading-[1.15] tracking-tight max-w-3xl">
            "A process you understand. A builder you trust. A home you love."
          </p>
          <Link to="/contact" data-testid="process-cta-btn" className="mt-10 inline-flex items-center gap-3 bg-[#F7F5F2] text-[#1A1A1A] font-mono text-[0.7rem] tracking-[0.2em] uppercase font-bold px-10 py-5 btn-sweep hover:text-[#F7F5F2] transition-colors duration-300">
            Start Step 01 — Let's Talk <ArrowRight size={14} />
          </Link>
        </FadeUp>
      </div>
    </section>
  </main>
);

export default OurProcess;
